export const GENERAL_PURPOSE_KEY = "general";

export const DEFAULT_PROVIDER_EMAIL_PURPOSES = [
  { key: "general", label: "General", enabled: true, sortOrder: 0 },
  {
    key: "clientPaymentNotification",
    label: "Client Payment Notification",
    enabled: true,
    sortOrder: 1,
  },
];

export const slugifyProviderEmailPurposeKey = (label, existingKeys = new Set()) => {
  const base = String(label || "")
    .trim()
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((part, index) =>
      index === 0
        ? part.toLowerCase()
        : part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    )
    .join("");

  if (!base) return "purpose";

  let key = base;
  let counter = 2;
  while (existingKeys.has(key)) {
    key = `${base}${counter}`;
    counter += 1;
  }
  return key;
};

const normalizeProviderEmailPurpose = (option = {}, index = 0, existingKeys = new Set()) => {
  const key =
    String(option.key || "").trim() ||
    slugifyProviderEmailPurposeKey(String(option.label || "").trim(), existingKeys);
  const label = String(option.label || "").trim();
  if (!label) return null;

  existingKeys.add(key);

  return {
    key,
    label,
    enabled: option.enabled !== false,
    sortOrder:
      option.sortOrder === 0 || option.sortOrder
        ? Number(option.sortOrder)
        : index,
  };
};

export const normalizeProviderEmailPurposes = (options) => {
  const source =
    Array.isArray(options) && options.length
      ? options
      : DEFAULT_PROVIDER_EMAIL_PURPOSES;
  const existingKeys = new Set();
  return source
    .map((option, index) => normalizeProviderEmailPurpose(option, index, existingKeys))
    .filter(Boolean)
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((option, index) => ({ ...option, sortOrder: index }));
};

export const moveProviderEmailPurpose = (options, fromIndex, direction) => {
  if (!Array.isArray(options)) return options;
  const index = Number(fromIndex);
  const nextIndex = index + Number(direction);
  if (!Number.isInteger(index) || index < 0 || index >= options.length) return options;
  if (nextIndex < 0 || nextIndex >= options.length) return options;

  const next = [...options];
  const [item] = next.splice(index, 1);
  next.splice(nextIndex, 0, item);
  return normalizeProviderEmailPurposes(
    next.map((row, sortOrder) => ({ ...row, sortOrder }))
  );
};

export const getEnabledProviderEmailPurposes = (options) =>
  normalizeProviderEmailPurposes(options).filter((option) => option.enabled);

export const serializeProviderEmailPurposes = (options = []) =>
  normalizeProviderEmailPurposes(options).map((option, index) => ({
    key: option.key,
    label: option.label,
    enabled: option.enabled,
    sortOrder: index,
  }));

export const validateProviderEmailPurposes = (options) => {
  const normalized = normalizeProviderEmailPurposes(options);
  const keys = new Set();

  for (const option of normalized) {
    if (keys.has(option.key)) {
      return `Duplicate email purpose key: ${option.key}`;
    }
    keys.add(option.key);
    if (!option.label) {
      return "Each email purpose must have a label";
    }
  }

  if (!normalized.length) {
    return "At least one email purpose is required";
  }

  return null;
};

export const providerEmailPurposeOptions = (options, currentValue) => {
  const data = getEnabledProviderEmailPurposes(options).map((option) => ({
    value: option.key,
    label: option.label,
  }));
  const current = String(currentValue || "").trim();
  if (current && !data.some((item) => item.value === current)) {
    const match = normalizeProviderEmailPurposes(options).find(
      (option) => option.key === current
    );
    data.push({ value: current, label: match?.label || current });
  }
  return data;
};
